export enum DocumentDetailsAction {
  SET_DOCUMENT_STATUS = 'set_document_status',
}
